import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';
import VideoWebcamRecorder from './FriendsRecorder';
import { API } from 'aws-amplify';

import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import loading from './../../loading-gif-png-5.gif';

/**
 *  Creates and runs the practice section for Unit3 Module2
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const Friends = (props) => {
  // Initialize variables to be used later
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [recording, setRecording] = useState(false);
  const [takingVideo, setTakingVideo] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [numVideo, setNumVideo] = useState(0);
  const [showStart, setShowStart] = useState(true);
  const [numConversation1, setNumConversation1] = useState(0);
  const [displayAudio, setDisplayAudio] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [displayAnimal, setDisplayAnimal] = useState(false);
  const [animateAnimal, setAnimateAnimal] = useState('');
  const [influencerVideo, setInfluencerVideo] = useState('');
  const [playVideo1, setPlayVideo1] = useState('');
  const [playVideo2, setPlayVideo2] = useState('');
  const [videos, setVideos] = useState([]);
  const [displayInfluencer, setDisplayInfluencer] = useState(false);
  const [conversation1, setConversation1] = useState(false);
  const [conversation2, setConversation2] = useState(false);
  const [example, setExample] = useState(true);
  const [animalSize, setAnimalSize] = useState(props.bigAnimal  ? (props.lizard ? 'lizard' : 'bigAnimal') : 'animateAnimal15')
  const [score, setScore] = useState(0);
  const [displayBullying, setDisplayBullying] = useState(false);
  
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
  const Exit = generateImageUrl('images/Images/close.png')

  const updateScore = async () => {
    try {
        await API.post('TIR', '/v3/student/result', {
        body: {
            student_id: login.studentid,
            metric: `${props.name}_skills_scorecard`,
            result: JSON.stringify({
            day: props.day,
            topic: props.subTitle,
            created: new Date().toISOString(),
            values: [{ value: score, target: props.conversation === 'FRIENDS' ? 3 : props.gradingQuestions.filter(question => question !== null && question.grade).length }],
            }),
        },
        });
    } catch (error) {
        console.log(error);
    }
  };

  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };

  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function handleAudioEnded() {
    setAudioReady(false);
    setDisplayAudio(false);
    setDisplayAnimal(false);
    if (animateAnimal === props.practiceMessage) {
      setDisplayInfluencer(true);
    } else if (animateAnimal === props.practiceConversation) {
      displayConversation();
    } else if (animateAnimal === props.awesomeJob) {
      updateScore();
      props.finish();
    }
  }

  useEffect(() => {
    let timer;
    if(displayAudio && isIOS()) {
      timer = setTimeout(() => {
        handleAudioEnded();
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [displayAudio]);

  useEffect(() => {
    if(recording) {
        setupGame();
    }
  }, [numVideo, recording]);

  useEffect(() => {
    if(recording) {
        displayConversation();
    }
  }, [numConversation1]);

  async function setupGame() {
    if (numVideo < props.texts.length) {
      setTakingVideo(true);
    } else {
      (async () => {
        dispatch({
          type: `FREEPLAY_SET_${props.level}_${props.conversation}_${props.topic}`,
          payload: 1,
        });
        setAnimalVoice(await getVideo(props.practiceMessageAudio, login));
        await GetUserVideo(`influencers/${props.influencerid}/conversation_affirmation.mp4`).then((data) => {
          setInfluencerVideo(data);
        });
        setAnimateAnimal(props.practiceMessage);
        setDisplayAnimal(true);
        
      })();
    }
  }

  async function displayConversation() {
      setPlayVideo1(videos[numConversation1]);
      setPlayVideo2(videos[numConversation1 + 1]);
      setConversation1(true);
  }

  // The HTML code for the practice
  return (
    <>
      {example && !recording && (
        <CloudfrontVideoFormat
          source={props.exampleVideo}
          close={props.setDisplayPractice}
          ended={() => {
            setExample(false);
            setRecording(true);            
          }}
      />)}
      {displayAudio && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            handleAudioEnded();
          }}
        >
          <source src={animalVoice} type="audio/mpeg"></source>
          <source src={animalVoice} type="audio/wav"></source>
          <source src={animalVoice} type="audio/ogg"></source>
        </audio>
      )}
      {recording && (
        <div
          id='recordpage'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            alt='back button'
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice();
            }}
          ></img>
          {takingVideo && (
            <VideoWebcamRecorder
              name={`${props.filename}_${numVideo}.mp4`}
              setScore={setScore}
              score={score}
              gradingQuestion={props.gradingQuestions[numVideo]}
              stepPrompt={props.stepPrompts ? props.stepPrompts[numVideo] : null}
              selectedCharacter={props.turns[numVideo] === 'Your Turn' ? props.selectedStudentCharacter : props.selectedFriendCharacter}
              background={props.background}
              turns={props.turns[numVideo] === 'Your Turn' ? props.studentName : props.friendName}
              outputText={props.texts[numVideo]}
              close={props.setDisplayPractice}
              videos={videos}
              setVideos={setVideos}
              title={props.title}
              subTitle={props.subTitle}
              ended={() => {
                setNumVideo(numVideo + 1);
                setTakingVideo(false);
              }}
            />
          )}
          {displayBullying && (
            <VideoWebcamRecorder
              name={`${props.filename}_bullying.mp4`}
              setScore={setScore}
              score={score}
              gradingQuestion={{question: `Did you say, “Step 1: Tell the bully to stop. Step 2: Walk away and stay away. Step 3: Tell a safe adult.”`, grade: true}}
              selectedCharacter={props.selectedStudentCharacter}
              instruction={generateImageUrl('media/Freeplay/bullying_practice_intro.mp4')}
              background={props.background}
              turns={props.studentName}
              outputText={`Say the three steps to stop bullying.`}
              close={props.setDisplayPractice}
              title={props.title}
              subTitle={'Stop Bullying'}
              ended={() => {
                setDisplayBullying(false);
                setAnimateAnimal(props.awesomeJob);
                setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                setDisplayAnimal(true);
              }}
            />
          )}
          {displayAnimal && !audioReady && (
            <img alt='loading' id='loading' src={loading} />
          )}
          {displayAnimal && (
            <img
              alt='animal'
              className={animalSize}
              style={audioReady ? {} : { display: 'none' }}
              onLoad={() => setDisplayAudio(true)}
              src={animateAnimal}
            />
          )}
          {displayInfluencer && (
            <div id='influencerVideo'>
              <video
                style={videoPlayer}
                autoPlay
                controls={isIOS() ? showStart : false}
                onPlaying={() => {
                  setShowStart(false);
                }}
                onEnded={() => {
                  setShowStart(true);
                  setAnimalVoice(getVideo(props.practiceConversationAudio, login));
                  setAnimateAnimal(props.practiceConversation);
                  setDisplayAnimal(true);
                  setDisplayInfluencer(false);
                }}
                playsInline
              >
                <source src={influencerVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
          {conversation1 && (
            <div className='recorder-scroll'>
              <div id='border'>
                <video
                  id='record-video'
                  autoPlay
                  controls={isIOS() ? showStart : false}
                  onPlaying={() => {
                    setShowStart(false);
                  }}
                  onEnded={() => {
                    setShowStart(true);
                    setConversation1(false);
                    if (numConversation1 > props.texts.length - 1) {
                      if(props.conversation === 'FRIENDS'){
                        setDisplayBullying(true)
                      }
                      else{
                        setAnimateAnimal(props.awesomeJob);
                        setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                        setDisplayAnimal(true);
                      }
                    } else {
                      setConversation2(true);
                    }
                  }}
                  onError={() => {
                    setConversation1(false);
                    if (numConversation1 > props.texts.length - 1) {
                      if(props.conversation === 'FRIENDS'){
                        setDisplayBullying(true)
                      }
                      else{
                        setAnimateAnimal(props.awesomeJob);
                        setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                        setDisplayAnimal(true);
                      }
                    } else {
                      setConversation2(true);
                    }
                  }}
                  playsInline
                >
                  <source src={playVideo1} type='video/mp4'></source>
                </video>
              </div>
            </div>
          )}
          {conversation2 && (
            <div className='recorder-scroll'>
              <div id='border'>
                <video
                  id='record-video'
                  autoPlay
                  controls={isIOS() ? showStart : false}
                  onPlaying={() => {
                    setShowStart(false);
                  }}
                  onEnded={() => {
                    setShowStart(true);
                    setConversation2(false);
                    if (numConversation1 === props.turns.length - 1) {
                      if(props.conversation === 'FRIENDS'){
                        setDisplayBullying(true)
                      }
                      else{
                        setAnimateAnimal(props.awesomeJob);
                        setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                        setDisplayAnimal(true);
                      }
                    } else {
                      setNumConversation1(numConversation1 + 2);
                    }
                  }}
                  onError={() => {
                    setConversation2(false);
                    if (numConversation1 === props.turns.length - 1) {
                      if(props.conversation === 'FRIENDS'){
                        setDisplayBullying(true)
                      }
                      else{
                        setAnimateAnimal(props.awesomeJob);
                        setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                        setDisplayAnimal(true);
                      }
                    } else {
                      setNumConversation1(numConversation1 + 2);
                    }
                  }}
                  playsInline
                >
                  <source src={playVideo2} type='video/mp4'></source>
                </video>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default Friends;
